import React, { Component } from "react";
import { Button, Col, DatePicker, Form, Input, Layout, Modal, Row, Select, Spin, Switch, Checkbox, Typography, message, Image, Empty } from 'antd';
import { Link } from 'react-router-dom'
import ListSort from "../../../ExternalComponent/ListSort";

import ModalPregunta from './ModalPregunta';
import ModalEncuesta from '../ModalEncuesta';
import ModalPreguntaVisualizar from './ModalPreguntaVisualizar';


import { ExclamationCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import '../../../../styles/preguntas.css';
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import locale from 'antd/es/date-picker/locale/es_ES';

const axios = require("axios").default;
const Moment = require('moment');
const moment = Moment;

const { Option } = Select;
const { Content } = Layout;


const { Title, Text, Paragraph } = Typography;

const { RangePicker } = DatePicker;



/**
 *
 *
 * @export
 * @class Preguntas
 * @extends {Component}
 */
export default class Preguntas extends Component {

    static propTypes = {
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'list-sort-demo',
    };

    modalQuestionReference = React.createRef();
    modalTipoEncuestaReference = React.createRef();
    formSurvey = React.createRef();

    state = {

        tipo: {
            value: '',
            text: ''
        },
        dataArray: [],

        users: {
            data: [],
            page: 1,
            quantity: 0,
            limit: 8,
            search: "",
            loading: false
        },

        profiles: {
            data: [],
            page: 1,
            quantity: 0,
            limit: 8,
            search: "",
            loading: false
        },

        targets: {
            data: [],
            page: 1,
            quantity: 0,
            limit: 8,
            search: "",
            loading: false
        },

        update: false,

        nuevaPregunta: true,
        itemText:{
            _id:undefined
        },

        modalModalPregunta: false,
        modalTipoEncuesta: false,
        modalDetalleLinea: false,

        lineaSeleccionada: [],
        preguntaView: undefined,
        redirect: false,
        pregunta: null,
        form: {},
        loading: false,


        updateFormValues: true,

    };

    /**
     * @methodOf Preguntas
     *
     * @function componentDidUpdate
     * @description Actualizamos los valores del fomulario al camabiar cualquier estado.
     * */
    async componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS): void {
        const { updateFormValues } = this.state;
        const { updateNavigationInformation } = this.props;
        if (updateFormValues && updateNavigationInformation) {
            await this.setState({ updateFormValues: false })
            await this.updateFormValues();
        }
    }


    /**
     * @methodOf Preguntas
     *
     * @function componentDidMount
     * @description Obtenemos todas las paginaciones y avtualizaciones los falores del formulario
     * */
    async componentDidMount(): void {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.props.updateNavigationInformation('Crear Encuesta');
        const { users, targets, profiles } = this.state;
        this.getDataPagination("/usuarios", "users", users.page, users.quantity, users.limit, users.search);
        this.getDataPagination("/perfiles", "profiles", profiles.page, profiles.quantity, profiles.limit, profiles.search);
        this.getDataPagination("/targets", "targets", targets.page, targets.quantity, targets.limit, targets.search);
        this.updateFormValues();

    }

    /**
     *
     *
     * @memberof Preguntas
     *
     * @description Actualizo la lista de preguntas del formulario.
     */
    updateFormValues = async () => {
        const { state } = this.props.history.location
        const params = this.props.match.params;
        let values = state;


        if (values !== undefined) {

            try {
                if (values['range-dates'] !== undefined)
                    values['range-dates'] = values['range-dates'].map(item => Moment(item))
                this.state.form = values;
                await this.setState({
                    form: values,
                    dataArray: values.preguntas
                })
                this.formSurvey.current.resetFields();

                this.setSurveyType(this.state.form.tipo.value)
            } catch (e) {
                console.log('e', e)
            }
        } else this.setSurveyType(params.var)
    }

    crearPregunta = async () => {
        this.setState({ nuevaPregunta: true, itemText: undefined, pregunta:undefined, indexText: undefined });

        setTimeout(() => {
            this.showModal("modalModalPregunta")
        }, 50);

    }

    editarPregunta = async () => {
        this.setState({ nuevaPregunta: false });

        setTimeout(() => {
            this.showModal("modalModalPregunta")
        }, 50);

    }

    /***************************  Modales *********************************/
    /**
     * @methodOf ModalEncuesta
     * @description Abre el modal
     * */
    showModal = async (tipo) => {
        this.state[tipo] = true;
        this.forceRender();
    }

    /**
     * @methodOf ModalEncuesta
     * @description Cierra el modal
     * */
    hideModal = async (tipo) => {
        this.state[tipo] = false;
        this.state.nuevaPregunta = false;
        this.state.lineaSeleccionada = [];
        return this.forceRender();
    };

    /**
     * @methodOf ModalEncuesta
     * @description Cierra el modal
     * */
    forceRender = () => this.setState({ update: !this.state.update })

    /*************************** Metodos del Formulario de Encuesta*********************************/
    /**
     * @methodOf Preguntas
     * @function setSurveyType
     *
     * @description Recibe como parametro un string, que puede ser voc o generica. En caso de no ser ninguna de estas, abre el modal de seleccion para que el usuario pueda seleccionar su tipo de encuesta.
     * */
    setSurveyType = (value, defaultE = true) => {
        switch (value) {
            case 'generica':
            case 'general':
                this.setState({
                    tipo: {
                        value: "generica",
                        text: "Genérica"
                    },
                    modalTipoEncuesta: false
                })
                break;
            case 'voc':
                this.setState({
                    tipo: {
                        value: "voc",
                        text: "Voz del Cliente"
                    },
                    modalTipoEncuesta: false
                })
                break;
            default:
                if (defaultE)
                    this.getSurvey(value)
                break;
        }
    };

    /**
     * @methodOf Preguntas
     * @function getSurvey
     *
     * @description Si hay un ID, lo pone en la encuesta y lo declara
     *
     * */
    getSurvey = async (surveyId) => {
        this.props.updateNavigationInformation('Editar Encuesta');
        this.setState({ loading: true })
        axios.get('/encuestas/id', {
            params: {
                id: surveyId,
                imagenes_info: true
            }
        }).then(async ({ data }) => {
            data = data.data;
            this.setSurveyType(data.tipo, false)

            const form = {
                _id: data._id,

                categorias: data.categorias.map(item => {
                    return { key: item.nombre, value: item._id, label: item.nombre }
                }),
                reportes: data.reportes.map(item => {
                    return { key: item.nombre, value: item._id, label: item.nombre }
                }),
                target: data.targets.map(item => {
                    return { key: item.nombre, value: item._id, label: item.nombre }
                }),
                nombre: data.nombre,

                descripcion: data.descripcion,
                //estatus: data.estatus,
                estatus: data.activo,

                'range-dates': [moment(data.fecha_inicio), moment(data.fecha_final)]
            };

            this.formSurvey.current.resetFields();

            await this.setState({
                form,
                dataArray: data.preguntas,
                loading: false,
            });

        })
            .catch(({ response }) => {
                console.log('response', response)
            })
    }


    /**
     * @methodOf Preguntas
     * @function saveTextQuestion
     *
     * @description Guarda un arreglo de pregunta de texto en el arreglo general.
     *
     * */
    saveTextQuestion = async (data, index) => {

        data.tipo = "text";
        let { dataArray, indexText } = this.state;
        if (this.state.indexText !== undefined && this.state.indexText !== null) {

            dataArray[indexText].condicional = data.condicional;
            dataArray[indexText].genero = data.genero;
            dataArray[indexText].nombre = data.nombre;
            dataArray[indexText].pregunta = data.pregunta;
            dataArray[indexText].respuestas = data.respuestas;

        } else {
            dataArray.push(data)
        }

        this.setState({
            dataArray: dataArray,
            modalModalPregunta: false,
            indexText: undefined,
            itemText: undefined,
        })

    }


    /**
     * @memberOf Preguntas
     * @function getDataPagination
     *
     * URL, type, page, quantity, limit, search
     * @param URL
     * @description URL a la cual se obtendrá la paginación.
     *
     * @param type
     * @description Es el nombre que tiene el objeto que almacena la paginacion, aqui es users, targets o profiles..
     *
     * @param page
     * @description Numero de pagina de la paginacíon.
     *
     * @param quantity
     * @description Total de registros.
     *
     * @param limit
     * @description Limite de Elementos en la paginación.
     *
     * @param search
     * @description Si hay algo que buscar, que lo busque.
     *
     * */
    getDataPagination = async (URL, type, page, quantity, limit, search) => {
        /* Para que funcione, necesito declarado un objeto en el estado con la siguiente estructura */
        //Obtengo el objeto del estado
        let before = this.state[type];
        //Activo el LOADING
        before.loading = true;
        this.state[type] = before;

        //Renderizo con lo nuevos valores
        this.setState({ update: !this.state.update })
        //hago la solicitud
        return axios.get(URL, {
            params: { page, quantity, limit, search },
            headers: { Authorization: sessionStorage.getItem("token") }
        })
            .then(response => {
                //Actualizo los valores con la nueva paginación. Debe ser un AGGREGATAE en el servidor.
                const reponseData = response.data.data;
                const { page, limit, search } = this.state[type];
                const pagination = {
                    data: reponseData.itemsList,
                    page: page,
                    quantity: reponseData.itemCount,
                    limit: limit,
                    search: search,
                    loading: false
                };
                //Actualizo el objeto con los nuevos valores en la paginacion
                this.state[type] = pagination;
                //Renderizo
                this.setState({ update: !this.state.update })
            })
            .catch(error => {
                console.log('error', error)
            })
    };


    /**
     * @methodOf Preguntas
     *
     * @function delete
     * @description Elimina una encuesta
     *
     * */
    deleteQuestion = (item, i) => {
        const component = this;
        const { form, dataArray } = this.state;

        //si no esta guardado en la BD
        if(item._id === undefined){
            Modal.confirm({
                icon: <ExclamationCircleOutlined />,
                title: '¿Estas seguro de eliminar esta pregunta?',
                onOk() {
                    let imagenesArray = []

                    dataArray.splice(i,1)
                    component.setState({dataArray})

                    if(item.tipo === 'image')
                        component.deleteImages(item)
                },
            });

        } else {
            Modal.confirm({
                icon: <ExclamationCircleOutlined />,
                title: '¿Estas completamente seguro de eliminar esta pregunta?',
                content: 'Al hacerlo, tambien eliminaras los resultados asociadas a ella y toda la información asociada a esta pregunta.',
                onOk() {
                    if (form._id !== null && form._id !== undefined) {
                        return axios.post("/preguntas/delete", {
                            id: form._id,
                            pregunta_id: item._id
                        })
                            .then(({ data }) => {
                                dataArray.splice(i, 1);
                                component.setState({
                                    dataArray
                                })
                            })
                            .catch(() => Modal.error({
                                title: "No fué posible eliminar esta pregunta. Contacte al equipo de desarollo.",
                            }))
                    }
                    dataArray.splice(i, 1);
                    component.setState({
                        dataArray
                    })
                },
            });
        }

        
    }

    /**
     *
     * @methodOf Preguntas
     *
     * @function deleteImages
     * @description elimina imagenes , que aun no estan gurdadas en la encuesta
     *
     * */
    deleteImages = (item) => {
        let arrayImages = []
        item.respuestas.forEach(resp => {
            resp.imagenes.forEach(img => {
                arrayImages.push(img.name)
            })
        })

       axios.post('/upload/multiple-delete', {
            multi: arrayImages
        })
        .then(({ data }) => {
            //todo bien
        })
        .catch(() => {
            // no importa
        })
    }

    /**
     *
     * @methodOf Preguntas
     *
     * @function editQuestion
     * @description Actualizamos una pregunta de texto.
     *
     * @param item
     * @description Es el objeto pregunta.
     *
     * @param tipo
     * @description Es numero de pregunta en la lista
     * */
    editQuestion = (item, i) => {
        //Obtenemos los valores format
        const { getFormValues } = this;
        if (item.tipo === "text") {
            this.setState({
                nuevaPregunta: false,
                itemText: item,
                pregunta:item,
                indexText: i
            })
            setTimeout(() => {
                this.showModal("modalModalPregunta")
            }, 250);
        } else
            this.setRedirect({
                pathname: "/admin/encuestas/pregunta",
                state: {
                    nuevaPregunta: false,
                    survey: getFormValues(),
                    item: item,
                    index: i
                }
            })
    }

     /**
     *
     * @methodOf Preguntas
     *
     * @function detalleLinea
     * @description Pone la pregunta a visualizar en el state y abre el modal
     *
     * */
    detalleLinea = (item, i) => {
       this.setState({modalDetalleLinea: true, preguntaView: item})
    }

    /**
     *
     * @methodOf Preguntas
     *
     * @function deleteLabel
     * @description Elimina la etiqueta "Label" de los arreglos que generan los Select Multiples. Es un arreglo que contiene continue metodos circulares que rompen la estructura.
     *
     * */
    deleteLabel = (element) => {
        let newelement = [];
        if (element !== undefined) {
            newelement = element.map(el => {
                return { value: el.value }
            })
        }
        return newelement
    }


    /**
     * @methodOf Preguntas
     * @function getFormatArray
     *
     * @description Transforma la info del formulario a algo que el webservice pueda interpretar
     *
     * */
    getFormatArray = (values) => {
        let newValues = {};

        // newElement
        //Itero el objeto generado
        for (let key in values) {

            //Obtengo el objeto generado, y verfico si es un arreglo
            const element = values[key];
            if (Array.isArray(element)) {

                let newElement = [];

                // Si es un arreglo, ocupoverificar si es arreglo de moments (fechas) o un arreglo de los selects
                for (let x = 0; x < element.length; x++) {

                    //Si es una fecha
                    if (Moment.isMoment(element[x])) {
                        //Genero la fecha
                        newElement[x] = element[x].format("YYYY-MM-DD")
                    } else if (element[x].label !== undefined && element[x].key !== undefined) {
                        //Intento oobteneos los valores,
                        try {
                            // {key: item.nombre, value: item._id}
                            newElement[x] = {
                                key: element[x].key,
                                label: element[x].label.props.children[0],
                                value: element[x].key,
                            }
                        } catch (e) {
                            // si no puedo, solo pongo el valor a lo cholo
                            newElement[x] = element[x];
                        }
                    } else {
                        //Si no es nada, entonces debe ser texto (quiero suponer eso) entonces agrego l elemento tal cual
                        newElement[x] = element[x];
                    }
                }
                // Aggrego el elemento al nuevo arreglo
                newValues[key] = newElement;
            } else {
                // Si no es un arreglo, que se joda, lo ponga tal cual y ya.
                newValues[key] = element
            }
        }
        return newValues;
    }

    /**
     * @memberOf Preguntas
     * @function getFormValues
     *
     * @description Obtenemos los valores del formulario
     *
     * */
    getFormValues = () => {
        let values = this.getFormatArray(this.formSurvey.current.getFieldsValue());
        values.preguntas = this.state.dataArray;
        values.tipo = this.state.tipo;
        return values;
    }

    renderGenero(genero) {
        let texto = ''
        switch (genero) {
            case 0:
                texto = "Masculino"
                break;
            case 1:
                texto = "Femenino"
                break;
            case 2:
                texto = "Ambos"
                break;
            case 3:
                texto = "N/A"

                break;

            default:
                texto = 'Sin Asignar'
                break;
        }
        return <Text>{texto}</Text>;
    }
    /**
     * @memberOf Preguntas
     * @function onFinish
     *
     * @description Guarda o actualiza la encuesta.
     *
     * */
    onFinish = (values) => {
        values.tipo = this.state.tipo.value;
        values.preguntas = this.state.dataArray;
        values.categorias = this.deleteLabel(values.categorias);
        values.reportes = this.deleteLabel(values.reportes);
        values.target = this.deleteLabel(values.target);

        axios.post('/encuestas/add', values)
            .then(e => {
                if (e.data.success) {
                    message.success("Datos de la Encuesta guardados, ¡exitosamente!")
                    this.setRedirect("/admin/encuestas")
                }
                else {
                    message.error("¡Ooops! NO se han guardado los datos de la Encuesta")
                }
            })
            .catch(r => {
                console.log('errr', r)
                message.error("¡Ooops! NO se han guardado los datos de la Encuesta")
            })
    }

    /**
     * @memberOf Preguntas
     * @function setRedirect
     *
     * @description Configura la redireccion
     *
     * */
    setRedirect = (to) => {
        this.to = to;
        this.props.history.push(to);
    };

    /**
     * @memberOf Preguntas
     * @function disabledDate
     *
     * @description desabilita fechas anteriores a la de la actual
     *
     * */
    disabledDate = (current) => {
        return current < moment().subtract(1, 'days')
    }



    render =() => {

        const { hideModal, saveTextQuestion, modalQuestionReference, modalTipoEncuestaReference, setSurveyType, formSurvey, setRedirect, onFinish, deleteQuestion, getFormValues, editQuestion } = this;

        const { tipo, users, targets, profiles, modalModalPregunta, modalTipoEncuesta, dataArray, pregunta, itemText, indexText, nuevaPregunta, modalDetalleLinea, lineaSeleccionada } = this.state;

        return <Content className="page-main" style={{ padding: '30px' }}>
            <Spin tip="Espere un momento por favor..." spinning={this.state.loading}>
                <Form
                    layout="vertical"
                    ref={formSurvey}
                    initialValues={this.state.form}
                    onFinish={onFinish}
                    onError={(e) => {
                        console.log('e', e)
                    }}
                >
                    <Form.Item name="_id" noStyle>
                        <Input type="hidden" />
                    </Form.Item>

                    <div className="page-content">
                        <div className="form-survey">

                            <Row className="form-survey-content">
                                {/* NOMBRE */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="nombre"
                                        label="Nombre de Encuesta"
                                        className="form-item"
                                        rules={[{
                                            message: "La encuesta debe de tener un nombre.",
                                            required: true
                                        }]}
                                    >
                                        <Input className="input" placeholder="Nombre de encuesta" title="Nombre de encuesta" />
                                    </Form.Item>
                                </Col>

                                {/* TIPO DE ENCUESTA */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        label="Tipo de Encuesta"
                                    >
                                        <a onClick={e => {
                                            e.preventDefault();
                                            this.setState({ modalTipoEncuesta: true })
                                        }} className="survey-type">{tipo.text}</a>
                                    </Form.Item>
                                </Col>

                                {/* TARGET */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="target"
                                        label="Target"
                                    >
                                        <Select
                                            style={{ marginTop: "15px" }}
                                            className="input-box"
                                            placeholder="Target de encuesta"
                                            title="Target de encuesta"

                                            mode="multiple"
                                            labelInValue
                                            filterOption={false}
                                            onSearch={(search) => this.getDataPagination("/targets", "targets", targets.page, targets.quantity, targets.limit, search)}
                                            notFoundContent={targets.loading ? <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 34 }} spin />} /> : null}
                                        >
                                            {targets.data.map((user, index) => <Option value={user._id} key={index}>{<span>{user.nombre} </span>}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {/* DESCRIPCIÓN */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="descripcion"
                                        label="Descripción de Encuesta"
                                        className="form-item"
                                        rules={[{
                                            message: "La encuesta debe de tener una descripción.",
                                            required: true
                                        }]}
                                    >
                                        <Input.TextArea maxLength={200} className="input" placeholder="Descripción de encuesta" title="Descripción de encuesta, máximo 200 caracteres" />
                                    </Form.Item>
                                </Col>

                                {/* ESTATUS */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="estatus"
                                        label="Estatus Actual"
                                        valuePropName="checked"
                                    >
                                        <Switch title="Estatus actual de encuesta"
                                            style={{ marginTop: "15px" }}
                                        />
                                    </Form.Item>
                                </Col>

                                {/* ENVIO DE REPORTES */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="reportes"
                                        label="Envío de Reportes"
                                    >
                                        <Select
                                            mode="multiple"
                                            className="input-box"
                                            placeholder="Envío de Reportes de encuesta"
                                            title="Envío de Reportes de encuesta"

                                            labelInValue
                                            filterOption={false}
                                            onSearch={(search) => this.getDataPagination("/usuarios", "users", users.page, users.quantity, users.limit, search)}
                                            notFoundContent={users.loading ? <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 34 }} spin />} /> : null}
                                            style={{ marginTop: "15px" }}
                                        >
                                            {users.data.map((user, index) => <Option value={user._id} key={index}>{<span>{user.nombre} </span>}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {/* FECHAS */}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="range-dates"
                                        label="Fechas de Encuesta"
                                        rules={[{
                                            message: "La encuesta debe de tener un rango de disponibilidad.",
                                            required: true
                                        }]}
                                    >
                                        <RangePicker locale={locale} className="input" style={{ marginTop: "8px" }} disabledDate={this.disabledDate} />
                                    </Form.Item>
                                </Col>

                                {/* PERFILES*/}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    <Form.Item
                                        name="categorias"
                                        label="Perfiles"
                                    >
                                        <Select
                                            className="input-box"
                                            mode="multiple"

                                            placeholder="Perfiles de encuesta"
                                            title="Perfiles de encuesta"

                                            labelInValue
                                            filterOption={false}
                                            onSearch={(search) => this.getDataPagination("/perfiles", "profiles", users.page, users.quantity, users.limit, search)}
                                            notFoundContent={users.loading ? <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 34 }} spin />} /> : null}
                                            style={{ marginTop: "8px" }}
                                        >
                                            {profiles.data.map((user, index) => <Option value={user._id} key={index}>{<span>{user.nombre} </span>}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                {/* URL*/}
                                <Col xs={24} md={12} xl={8} className="form-survey-col">
                                    {(this.state.form._id !== undefined && (this.state.tipo.value === "generica" || this.state.tipo.value === "general")) ? <Form.Item
                                        name="URL"
                                        label={<div>URL de Encuesta <Button></Button></div>}
                                        className="form-item"
                                    >
                                        <Link target="_blank" to={"/encuesta/" + this.state.form._id}>{"/encuesta/" + this.state.form._id}</Link>
                                    </Form.Item> : null}
                                </Col>

                            </Row>

                            <Row className="form-survey-content">
                                <Col xs={{ span: 18, offset: 3 }} lg={{ span: 12, offset: 6 }}>
                                    <Form.Item>
                                        <Button className="v-button-primary" onClick={() => {
                                            formSurvey.current.submit()
                                        }}>Guardar</Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <h5 className="title-page">Preguntas #
                    <Button onClick={e => this.crearPregunta(e)}
                                type="primary" className="add-control">
                                <svg style={{ marginTop: '0.3em' }} width="20" height="20" viewBox="0 0 18 18" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.4298 11.5702C6.31805 11.5702 6.24069 11.5702 6.16046 11.5702C4.35817 11.5702 2.55587 11.5702 0.753582 11.5702C0.246418 11.5702 0 11.3266 0 10.8223C0 9.60172 0 8.38395 0 7.16332C0 6.68195 0.249284 6.4298 0.727794 6.4298C2.54441 6.4298 4.35817 6.4298 6.17478 6.4298C6.25215 6.4298 6.33238 6.4298 6.43266 6.4298C6.43266 6.33238 6.43266 6.25215 6.43266 6.17478C6.43266 4.36676 6.43266 2.55874 6.43266 0.747851C6.43266 0.243553 6.67622 0 7.18338 0C8.39542 0 9.60745 0 10.8195 0C11.3266 0 11.5673 0.243553 11.5673 0.753582C11.5673 2.55587 11.5673 4.35817 11.5673 6.16046C11.5673 6.24069 11.5673 6.32092 11.5673 6.43266C11.6533 6.43266 11.7307 6.43266 11.808 6.43266C13.616 6.43266 15.4241 6.43266 17.235 6.43266C17.7593 6.43266 18 6.67049 18 7.18911C18 8.40115 18 9.61318 18 10.8252C18 11.3209 17.7536 11.5673 17.2607 11.5673C15.4527 11.5673 13.6447 11.5673 11.8338 11.5673C11.7536 11.5673 11.6762 11.5673 11.5673 11.5673C11.5673 11.6562 11.5673 11.7335 11.5673 11.8138C11.5673 13.6218 11.5673 15.4298 11.5673 17.2407C11.5673 17.7622 11.3266 18 10.8052 18C9.59312 18 8.38109 18 7.16905 18C6.67622 18 6.4298 17.7507 6.4298 17.255C6.4298 15.447 6.4298 13.639 6.4298 11.8281C6.4298 11.7507 6.4298 11.6734 6.4298 11.5702Z"
                                        fill="white" />
                                </svg>
                            </Button></h5>

                        <Row className="questions">
                            <Row style={{ width: '100%' }}>
                                <Col span={3}><Text className="text-gray" style={{ marginLeft: 30 }}>No#</Text></Col>
                                <Col span={4}><Text className="text-gray">Nombre</Text></Col>
                                <Col span={6}><Text className="text-gray">Pregunta</Text></Col>
                                <Col span={6}><Text className="text-gray">Condicional</Text></Col>
                                <Col span={2}><Text className="text-gray">Género</Text></Col>
                                <Col span={3}></Col>
                            </Row>
                            <div className={`${this.props.className}-wrapper`}>
                                <div className={this.props.className}>
                                    <ListSort
                                        dragClassName="selectable-area"
                                        appearAnim={{ animConfig: { marginTop: [5, 30], opacity: [1, 0] } }}
                                    >

                                        {dataArray.map((item, i) => {

                                            let nombre = (item.nombre === undefined) ? item.texto : item.nombre;
                                            let pregunta = (item.pregunta === undefined) ? item.texto : item.pregunta;

                                            let pregunta_condicional = (item.condicional === undefined) ? null : item.condicional;
                                            let genero = (item.genero === undefined) ? 'Sin Asignar' : item.genero;

                                            return (
                                                <div key={i} className={`${this.props.className}-list`} style={{ height: 'auto' }}>
                                                    <Row style={{ width: '100%' }}>
                                                        <Col span={3}>
                                                            <Row>
                                                                <svg className="selectable-area" width="12" height="37"
                                                                    viewBox="0 0 12 37" fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <circle cx="2.5" cy="26.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="2.5" cy="2.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="9.5" cy="2.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="2.5" cy="10.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="9.5" cy="10.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="2.5" cy="18.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="9.5" cy="18.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="9.5" cy="26.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="2.5" cy="34.5" r="2.5" fill="#A4A4A4" />
                                                                    <circle cx="9.5" cy="34.5" r="2.5" fill="#A4A4A4" />
                                                                </svg>
                                                                <Paragraph style={{
                                                                    position: 'relative', top: '8px', left: '10px'
                                                                }}>{i}</Paragraph>
                                                            </Row>
                                                        </Col>
                                                        <Col span={4} className="flex-start">
                                                            <Text>{nombre}</Text>
                                                        </Col>
                                                        <Col span={6} className="flex-start">
                                                            <Text>{pregunta}</Text>
                                                        </Col>
                                                        <Col span={6} className="flex-start">

                                                            {(pregunta_condicional !== null && pregunta_condicional.activada === true) ?
                                                                <Checkbox checked={pregunta_condicional.activada} className="checkbox-disabled" disabled>{pregunta_condicional.texto}</Checkbox>
                                                                :
                                                                <Checkbox className="checkbox-disabled" disabled>Sin Asignar</Checkbox>
                                                            }

                                                        </Col>
                                                        <Col span={2} className="flex-start">
                                                            {this.renderGenero(genero)}
                                                        </Col>
                                                        <Col span={3} className="center">
                                                            <Button
                                                                title="Ver"
                                                                onClick={() => this.detalleLinea(item, i)}
                                                                className="btn-sortable btn-sortable-see"
                                                                style={{ backgroundColor: '#E88EFF' }}
                                                                type="primary"
                                                                icon={<svg width="18" height="10" viewBox="0 0 18 10"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M0 5.01403C0.826489 4.16301 1.6258 3.32658 2.52843 2.59948C3.2989 1.97879 4.11232 1.42319 5.00043 0.987138C5.86301 0.563397 6.76315 0.249607 7.71577 0.100641C8.99388 -0.0990248 10.2496 0.00112081 11.4862 0.376875C12.0627 0.55213 12.6139 0.78789 13.1502 1.06183C13.8759 1.43237 14.5517 1.88031 15.1973 2.37749C16.0916 3.06641 16.8893 3.85965 17.6691 4.67291C17.7218 4.72799 17.7749 4.78266 17.8299 4.83523C17.8824 4.88531 17.9376 4.93267 18 4.98858C17.8168 5.17719 17.6492 5.35599 17.4751 5.5277C17.0362 5.96041 16.6016 6.39813 16.1514 6.81895C15.6321 7.30445 15.0718 7.74008 14.486 8.14233C13.9404 8.51705 13.3697 8.84753 12.7703 9.12668C11.8652 9.54792 10.9224 9.83521 9.92783 9.94704C9.36522 10.0103 8.80344 10.0178 8.24104 9.96477C7.44961 9.89029 6.67768 9.71712 5.94101 9.41898C5.45558 9.22245 4.97927 8.99712 4.51623 8.75176C3.8555 8.40167 3.24766 7.96666 2.65954 7.50307C1.82226 6.84357 1.07191 6.09102 0.331923 5.32678C0.228405 5.22017 0.115551 5.12253 0 5.01403ZM9.01172 1.74553C7.22659 1.74219 5.76883 3.1941 5.76447 4.97919C5.76012 6.78306 7.19983 8.24936 8.9804 8.25479C10.7782 8.26021 12.2328 6.81102 12.2372 5.01049C12.2413 3.211 10.7968 1.74887 9.01172 1.74553ZM11.4854 1.47848C12.6336 2.3704 13.2718 3.52979 13.272 4.99985C13.272 6.47053 12.6332 7.63117 11.4829 8.52247C13.4852 7.81269 15.0749 6.50704 16.5377 5.0011C15.0787 3.48994 13.4848 2.19055 11.4854 1.47848ZM6.51649 1.47994C4.51955 2.19285 2.92777 3.49349 1.46565 5.00068C2.92943 6.50391 4.51914 7.80789 6.51628 8.52038C4.14074 6.80602 4.11481 3.21538 6.51649 1.47994Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M9 7C10.1046 7 11 6.10457 11 5C11 3.89543 10.1046 3 9 3C7.89543 3 7 3.89543 7 5C7 6.10457 7.89543 7 9 7Z"
                                                                        fill="white" />
                                                                </svg>} />
                                                            <Button
                                                                onClick={() => editQuestion(item, i)}
                                                                className="btn-sortable btn-sortable-edit"
                                                                style={{ backgroundColor: '#456EFF' }}
                                                                type="primary"
                                                                icon={<svg width="15" height="15" viewBox="0 0 15 15"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M11.5646 13.5527C11.5646 13.4858 11.5646 13.429 11.5646 13.3719C11.5646 12.1273 11.5637 10.8828 11.5663 9.63819C11.5666 9.5338 11.575 9.4248 11.6058 9.32589C11.7125 8.98245 12.0459 8.78608 12.4072 8.84173C12.7343 8.89191 12.9857 9.18258 12.999 9.52601C13.0004 9.55946 12.9999 9.5932 12.9999 9.62694C12.9999 11.155 13.0002 12.683 12.9999 14.211C12.9999 14.6903 12.7302 14.9737 12.2521 14.9974C12.161 15.002 12.0695 14.9991 11.9781 14.9991C8.25851 14.9991 4.53891 14.9991 0.819305 14.9991C0.285791 14.9991 0 14.7142 0 14.181C0 10.385 0 6.58877 0 2.79278C0 2.2942 0.289251 2.00094 0.783545 2.00065C2.19635 2.00007 3.60915 1.99921 5.02224 2.00151C5.40637 2.00209 5.68928 2.2547 5.74379 2.63158C5.79195 2.96493 5.57998 3.30145 5.24834 3.39978C5.14914 3.42919 5.04012 3.43669 4.93573 3.43698C3.83525 3.43957 2.73477 3.43871 1.63428 3.43871C1.57718 3.43871 1.5198 3.43871 1.45087 3.43871C1.45087 6.81426 1.45087 10.1786 1.45087 13.5527C4.81576 13.5527 8.17748 13.5527 11.5646 13.5527Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M11.0193 2C11.6819 2.66264 12.3464 3.32695 13 3.98042C11.3248 5.65538 9.64618 7.33339 7.979 9C7.33119 8.35181 6.66254 7.6825 6 7.0193C7.66051 5.35908 9.33965 3.67968 11.0193 2Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M15 2.2736C14.4242 2.84896 13.8427 3.4297 13.2716 4C12.514 3.24235 11.7526 2.48089 11 1.7283C11.5682 1.15927 12.1516 0.575045 12.7262 0C13.4787 0.752275 14.2376 1.5112 15 2.2736Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M4 11C4.34085 9.97294 4.67075 8.97891 4.99561 8C5.66018 8.66595 6.32729 9.33414 7 10.0079C6.02768 10.3293 5.02815 10.6599 4 11Z"
                                                                        fill="white" />
                                                                </svg>} />
                                                            <Button
                                                                className="btn-sortable btn-sortable-delete"
                                                                onClick={() => deleteQuestion(item, i)} type="primary"
                                                                icon={<svg width="14" height="16" viewBox="0 0 14 16"
                                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M1.26063 3.91361C0.979573 3.91361 0.717947 3.91384 0.45632 3.91361C0.124372 3.91315 0.000151068 3.78962 0.000151068 3.46207C0.000151068 3.29251 -0.000311578 3.12272 0.000382391 2.95316C0.00130768 2.6684 0.134319 2.534 0.417227 2.534C1.36565 2.53354 2.31385 2.53238 3.26227 2.53631C3.3548 2.53678 3.39551 2.50856 3.43021 2.42366C3.63401 1.92446 3.83294 1.42296 4.05617 0.932319C4.32266 0.346378 4.79432 0.0239132 5.43671 0.013041C6.4772 -0.00453957 7.51839 -0.00407693 8.55911 0.0128097C9.20658 0.0232192 9.6801 0.346378 9.94682 0.938565C10.1698 1.4336 10.3706 1.93858 10.5774 2.44078C10.607 2.51272 10.6438 2.53608 10.722 2.53585C11.6704 2.53284 12.6186 2.53377 13.567 2.534C13.8684 2.534 13.9987 2.66262 13.9994 2.96056C13.9998 3.14562 14.0005 3.33068 13.9994 3.51574C13.9977 3.76857 13.8599 3.91014 13.6059 3.91292C13.3246 3.91616 13.0433 3.91361 12.7403 3.91361C12.7403 3.97445 12.7403 4.02997 12.7403 4.08572C12.7403 7.11582 12.74 10.1459 12.7405 13.176C12.7405 13.7715 12.5788 14.309 12.1814 14.7634C11.8811 15.1066 11.5106 15.2852 11.0449 15.2843C8.35416 15.2797 5.66317 15.2788 2.97242 15.285C2.45657 15.2862 2.05823 15.0807 1.74155 14.6896C1.38809 14.2524 1.25994 13.7439 1.26017 13.1913C1.26156 10.1536 1.26086 7.11559 1.26086 4.07785C1.26063 4.02858 1.26063 3.97931 1.26063 3.91361ZM2.63885 3.91963C2.63885 3.98 2.63885 4.0258 2.63885 4.07184C2.63885 6.68579 2.63885 9.29951 2.63885 11.9135C2.63885 12.349 2.63909 12.7849 2.63885 13.2204C2.63862 13.418 2.69113 13.6007 2.78783 13.7719C2.8408 13.8656 2.90835 13.9105 3.02817 13.9105C5.68052 13.9063 8.33311 13.9068 10.9855 13.9102C11.0898 13.9105 11.1515 13.8709 11.2008 13.79C11.3181 13.5966 11.3627 13.3865 11.3625 13.161C11.3609 10.123 11.3614 7.08505 11.3616 4.04709C11.3616 4.00614 11.3616 3.96497 11.3616 3.91986C8.44877 3.91963 5.55121 3.91963 2.63885 3.91963ZM9.11174 2.52914C9.10735 2.50902 9.10619 2.49375 9.10087 2.48057C8.96855 2.15625 8.83531 1.83217 8.70299 1.50762C8.66829 1.42272 8.60537 1.38294 8.51469 1.38294C7.50867 1.38317 6.50288 1.38317 5.49685 1.38317C5.40664 1.38317 5.3421 1.42249 5.30694 1.50693C5.17046 1.83379 5.03398 2.16065 4.89819 2.48774C4.89333 2.49977 4.89495 2.51457 4.89356 2.52914C6.30186 2.52914 7.70368 2.52914 9.11174 2.52914Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M7.68689 8.90605C7.68689 9.83111 7.68712 10.7562 7.68666 11.681C7.68642 12.0021 7.56128 12.1254 7.23673 12.1258C7.06324 12.1263 6.88975 12.1268 6.71649 12.1256C6.45417 12.1235 6.31398 11.9866 6.31375 11.727C6.31306 9.84615 6.31306 7.96526 6.31375 6.08437C6.31375 5.83639 6.45139 5.6976 6.69937 5.69366C6.89599 5.69043 7.09262 5.69089 7.28901 5.69366C7.55156 5.69713 7.68619 5.83269 7.68642 6.09617C7.68758 7.0328 7.68689 7.96942 7.68689 8.90605Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M5.16251 8.90649C5.16251 9.82762 5.16251 10.749 5.16251 11.6701C5.16251 12.0071 5.04199 12.1263 4.70056 12.1265C4.5465 12.1265 4.39221 12.1265 4.23815 12.1265C3.91429 12.1263 3.78799 12.0021 3.78799 11.6812C3.78776 9.90812 3.78776 8.13526 3.78776 6.36217C3.78776 6.2657 3.78591 6.16947 3.78845 6.07301C3.79447 5.83799 3.92956 5.69942 4.16366 5.69457C4.36399 5.6904 4.56454 5.69179 4.76487 5.6941C5.02742 5.69711 5.16228 5.83359 5.16251 6.09661C5.16298 7.03347 5.16251 7.97009 5.16251 8.90649Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M8.83741 8.90362C8.83741 7.97856 8.83718 7.0535 8.83741 6.12844C8.83741 5.82147 8.96533 5.69401 9.27276 5.69332C9.45388 5.69285 9.63501 5.69124 9.81614 5.69378C10.0736 5.69725 10.2115 5.83211 10.2115 6.0868C10.2124 7.97162 10.2122 9.85644 10.2108 11.7413C10.2105 11.9809 10.0685 12.1218 9.82886 12.1255C9.6246 12.1287 9.42034 12.129 9.21608 12.1253C8.97967 12.1211 8.83787 11.9756 8.83764 11.7369C8.83671 10.7924 8.83741 9.84811 8.83741 8.90362Z"
                                                                        fill="white" />
                                                                </svg>} />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })}
                                    </ListSort>
                                </div>
                            </div>
                        </Row>

                    </div>
                </Form>
            </Spin>

            <Modal
                visible={modalModalPregunta}
                onCancel={async e => {
                    await hideModal("modalModalPregunta")
                    await this.setState({
                        itemText: undefined,
                        indexText: undefined,
                    })
                }}
                title={null}
                footer={null}
                className="modal-form crear-encuesta"
                destroyOnClose={true}
                closeIcon={<Button type="ghost" className="closable-button" onClick={hideModal}>
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M30.0019 27.6742L2.32776 0L2.66014e-05 2.32773L27.6742 30.0019L30.0019 27.6742Z"
                            fill="#E1E4ED" />
                        <path d="M2.32915 30.0033L30.0033 2.3291L27.6756 0.00136937L0.00141366 27.6755L2.32915 30.0033Z"
                            fill="#E1E4ED" />
                    </svg>
                </Button>}
            >
                <ModalPregunta
                    ref={modalQuestionReference}
                    nuevaPregunta={nuevaPregunta}
                    link={false}
                    onFinish={saveTextQuestion}
                    pregunta={pregunta}
                    itemText={itemText}
                    indexText={indexText}
                    accept={e => {
                        setRedirect({
                            pathname: "/admin/encuestas/pregunta",
                            state: {
                                survey: getFormValues(),
                            }
                        })
                    }}
                />
            </Modal>

            <ModalPreguntaVisualizar
                visible={this.state.modalDetalleLinea}
                pregunta={this.state.preguntaView}
                cleseMethod={()=>{
                    this.setState({modalDetalleLinea: false, preguntaView: undefined})
                }}
            />

            <ModalEncuesta
                ref={modalTipoEncuestaReference}
                visible={modalTipoEncuesta}
                hideModal={e => hideModal("modalTipoEncuesta")}
                link={false}
                accept={setSurveyType}
            />



        </Content>

    }
}

